import React from 'react';
import { PageToolbarController } from './toolbar';
import ServiceFactory from '../../library/service/factory';
import PageDelegate from '../../library/cms/page-delegate';
import Console from '../../library/console';

//base class for page embedded apps
export class PageEmbeddedApp extends React.Component{
    constructor(props){
         super(props)
         var data=this.props.initialData;
         this.entity=data.entity;
         this.entityType=data.entityType;
         this.entityName=data.entityName;
         this.actions=data.actions;
         this.mode=data.mode;
         this.media=data.media;
         this.page=data.page;
         this.pageTags=data.pageTags;
         this.pageTemplates=data.pageTemplates;
         this.pagesIndex=data.pagesIndex;
         this.dashboardIndex=data.dashboardIndex;
         this.pageEndpoint=data.pageEndpoint;
         this.pageSettingsEndpoint=data.pageSettingsEndpoint;
         this.pageRestoreEndpoint = data.pageRestoreEndpoint;
         var component={active:false,editMode:false};
         this.state={component:component};
     }

    componentDidMount() {
        if(this.entityType) {
            var Service = ServiceFactory.getType(this.entityType);
            this.Service= new Service();
        }
        var PageService=ServiceFactory.getType(this.pageEndpoint);
        this.PageService= new PageService();
        var PageSettingsService=ServiceFactory.getType(this.pageSettingsEndpoint);
        this.PageSettingsService= new PageSettingsService();
        var PageRestoreService = ServiceFactory.getType(this.pageRestoreEndpoint);
        this.PageRestoreService = new PageRestoreService();
        this.snackbar=this.toolbarController.snackbar;
        this.createDialog=this.toolbarController.createDialog;
        this.pageCreate=this.toolbarController.pageCreate;
        this.settingsDialog=this.toolbarController.settingsDialog;
        this.pageSettings=this.toolbarController.pageSettings;
    }

    get snackbarComponent(){
        return this.snackbar;
    }

    onCommand(id){
       switch(id){
           case 'view':
             this.onRedirect(this.actions.view);
             break;
           case 'edit':
             this.onRedirect(this.actions.edit);
             break;
           case 'create':
             this.onRedirect(this.actions.create);
             break;
           case 'manage-notification':
               this.gotoManageNotificationBar();
               break;  
           case 'pages-view':
             this.gotoPages(); 
             break;
           case 'page-create':
             this.createPage();
             break;
           case 'page-settings':
             this.showSettings(); 
             break;
           case 'page-delete':
              this.deletePage(this.page.id);
              break;
           case 'dashboard':
             this.gotoDashboard();
             break;  
           case 'toggle':
             this.toggleState();
             break; 
           case 'exit':
             this.resetState();
             break;
           case 'publish':
             this.setEntity();
             this.publish();
             break; 
           case 'delete':
             this.delete(this.entity.id);
             break;                 
       }
    }

    onRedirect(url){
       this.redirect(url); 
    }

    onDelete(entity){
        this.deleteFromList(entity.id);
    }

    onDeleteFromList(id){
    }

    onEdit(entity){
        var url=this.actions.edit + '/' + entity.id;
        this.redirect(url);
    }

    onCreateDialogAccept(){
        this.createDialog.enableAccept();
        var page=this.pageCreate.getComponentState();
        if(!page.tag || !page.template){
            this.snackbar.show('User Error: Please select a page tag and template');
        }else this.addPage(page);
    }

    onCreateDialogCancel(){
        this.createDialog.enableAccept();
        var page=this.pageCreate.resetComponentState();
    }

    onSettingsDialogAccept(){
        var page=this.pageSettings.getComponentState();
        this.savePageSettings(page);
    }

    onSettingsDialogCancel(){
        var page=this.pageSettings.resetComponentState();
    }

    onAddPageSuccess(page){
        if(page.isEmbeddedPage) return;
        setTimeout(()=>{
            location.href=page.permalink;
        },500);
    }

    setEntity(){
        var entity=this.component.getEntity();
        this.entity=entity;
    }

    setPageEntity(page){
        this.page=page;
    }

    redirect(url){
        location.href=url;
    }

    gotoManageNotificationBar() {
        location.href = '/Admin/NotificationAlert';
    }

    gotoDashboard(){
        if(this.dashboardIndex) location.href=this.dashboardIndex;
        else this.snackbar.show('Dashboard currently not available');
    }

    gotoPages(){
        if(this.pagesIndex) location.href=this.pagesIndex;
        else this.snackbar.show('Page listing currently not available');
    }

    publish(){
        if(!this.entity.id) this.add();
        else this.update();
    }

    delete(id){
        if(!id) this.snackbar.show('Error: cannot delete a new ' + this.entityName);
        else{
            this.Service.delete({id:id},(err,data)=>{
                if(!err){
                    this.entity=null;
                    this.snackbar.show('The ' + this.entityName + ' has been deleted');
                }else this.snackbar.show('Error deleting ' + this.entityName);
            });
        }
    }

    deleteFromList(id){
        if(!id) this.snackbar.show('Error: cannot delete a new ' + this.entityName);
        else{
            this.Service.delete({id:id},(err,data)=>{
                if(!err){
                    this.entity=null;
                    this.snackbar.show('The ' + this.entityName + ' has been deleted');
                    this.onDeleteFromList(id);
                }else this.snackbar.show('Error deleting ' + this.entityName);
            });
        }
    }

    add(){
        var msg='The ' + this.entityName + ' has been successfully published';
        var errMsg='Error publishing ' + this.entityName;
        this.Service.post(this.entity,(err,data)=>{
               if(!err){
                   this.entity=data;
                   this.snackbar.show(msg);
               }else this.snackbar.show(errMsg);
        });
    }

    update(){
        var msg='The ' + this.entityName + ' has been successfully published';
        var errMsg='Error publishing ' + this.entityName;
        this.Service.put(this.entity,(err,data)=>{
               if(!err){
                   this.entity=data;
                   this.snackbar.show(msg);
               }else this.snackbar.show(errMsg);
        }); 
    }

    addPage(page){
        var msg='The page has been successfully published';
        var errMsg='Error publishing page';
        this.PageService.post(page,(err,data)=>{
               if(!err){
                   this.snackbar.show(msg);
                   this.onAddPageSuccess(data);
               }else this.snackbar.show(errMsg);
        });
    }

    updatePage(){
        var msg='The page has been successfully published';
        var errMsg='Error publishing page';
        this.PageService.put(this.page,(err,data)=>{
               if(!err){
                   this.page=data;
                   this.snackbar.show(msg);
               }else this.snackbar.show(errMsg);
        }); 
    }

    deletePage(id){
        if(!id) this.snackbar.show('Error: cannot delete a new page');
        else{
            this.PageService.delete({id:id},(err,data)=>{
                if(!err){
                    this.page=null;
                    this.snackbar.show('The page has been deleted');
                }else this.snackbar.show('Error deleting page');
            });
        }
    }

    restorePage(page) {
        var message = '';
        this.PageRestoreService.post(page, (err, data) => {
            if (err) {
                message = 'Error restoring page...';
            } else {
                message = 'Page Restored Successfully!';
            }
            this.snackbar.show(message);
        });
    }

    savePageSettings(page){
        var msg='The page settings have been successfully saved';
        var errMsg='Error saving page settings';
        this.PageSettingsService.put(page,(err,data)=>{
               if(!err){
                   this.page=data;
                   this.snackbar.show(msg);
               }else this.snackbar.show(errMsg);
        }); 
    }

    createPage(){
        this.pageCreate.setComponentState(this.defaultPageEntity(),this.pageTags,this.pageTemplates);
        this.createDialog.disableAccept();
        this.createDialog.show();
    }

    showSettings(){
        this.pageSettings.setComponentState(this.page);
        this.settingsDialog.show();
    }

    toggleState(){
       if(this.state.component.active) this.state.component.active=false;
       else this.state.component.active=true;
       this.setState(this.state.component);
    }

    resetState(){
        this.state.component.active=false;
        this.setState(this.state.component);
    }

    arrayFindIndexById(arr,id){
        var index=-1;
        var len=arr.length;
        for(var i=0;i<len;i++){
            if(arr[i]['id']===id){
                index=i;
                break;
            }
        }
        return index; 
    }

    arrayDeleteItemById(arr,id){
        var clone=arr.slice(0);
        var index=this.arrayFindIndexById(clone,id);
        if(index>-1){
            clone.splice(index,1);
        }
        return clone;
    }

    defaultPageEntity(){
        return{
            id:null,
            identifier:null,
            tag:null,
            permalink:"",
            title:"",
            template:null,
            keywords:"",
            metaDescription:"",
            published:false,
            isEmbeddedPage:false,
            status:null,
            showInMenu:false,
            menuOrder:0,
            dateCreated:new Date(),
            dateUpdated:new Date(),
            editedBy:null,
            version:0,
            cssClass:null,
            content:null,
            jsonContent:null
        };
    }
}

//base class for page management 
export class PageApp extends PageEmbeddedApp{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    setEntity(){
        this.page.content=PageDelegate.getContent();
    }

    toggleState(){
       PageDelegate.toggle();
    }

    resetState(){
       console.log('reset state'); 
       PageDelegate.resetToggle();
    }

    publish(){
       if(this.page.id) this.updatePage();
       else if(this.page.allowOverride){
          this.addPage(this.page);
       }else{
          this.snackbar.show('No page to publish');
       }
    }

    render(){
        Console.log(this.props.initialData.authorized);
        return(
            <div>
               <PageToolbarController 
                  showToolbar={this.props.initialData.showToolbar} 
                  onCommand={this.onCommand.bind(this)} 
                  mode={this.mode} 
                  authorized={this.props.initialData.authorized} 
                  ref={(ref) => this.toolbarController = ref} 
                  onCreateDialogAccept={this.onCreateDialogAccept.bind(this)} 
                  onCreateDialogCancel={this.onCreateDialogCancel.bind(this)} 
                  onSettingsDialogAccept={this.onSettingsDialogAccept.bind(this)} 
                  onSettingsDialogCancel={this.onSettingsDialogCancel.bind(this)} 
                 />
            </div>
        );
    }
}

export default {PageEmbeddedApp,PageApp}